export const APIKEY_SET_GRID = 'APIKEY_SET_GRID';
export const APIKEY_SET_DATA = 'APIKEY_SET_DATA';
export const APIKEY_SET_DATA_ALL = 'APIKEY_SET_DATA_ALL';
export const APIKEY_SET_LAST_PAGE = 'APIKEY_SET_LAST_PAGE';
export const APIKEY_SET_TOTAL_ROWS = 'APIKEY_SET_TOTAL_ROWS';
export const APIKEY_SET_CURRENT_ROW = 'APIKEY_SET_CURRENT_ROW';
export const APIKEY_SET_RELOAD_DATA = 'APIKEY_SET_RELOAD_DATA';
export const APIKEY_SET_LOADING = 'APIKEY_SET_LOADING';
export const APIKEY_SET_LOADING_ALL = 'APIKEY_SET_LOADING_ALL';
export const APIKEY_TOGGLE_REVOKE_CONFIRM_MODAL =
  'APIKEY_TOGGLE_REVOKE_CONFIRM_MODAL';
export const APIKEY_TOGGLE_CREATE_OR_ADD_MODAL =
  'APIKEY_TOGGLE_CREATE_OR_ADD_MODAL';
